export enum VossRevenueRecognitionBehaviour {
    Normal = 0,
    CreateTopLine = 1,
    UseProductGroupName = 2,
    DontCreateTopLine = 3,
}

export const VossRevenueRecognitionBehaviourText: Record<VossRevenueRecognitionBehaviour, string> = {
    [VossRevenueRecognitionBehaviour.Normal]: 'vossRevenueRecognitionBehaviour.normal',
    [VossRevenueRecognitionBehaviour.CreateTopLine]: 'vossRevenueRecognitionBehaviour.createTopLine',
    [VossRevenueRecognitionBehaviour.UseProductGroupName]: 'vossRevenueRecognitionBehaviour.useProductGroupName',
    [VossRevenueRecognitionBehaviour.DontCreateTopLine]: 'vossRevenueRecognitionBehaviour.dontCreateTopLine',
};

export const revenueRecognitionBehaviours = Object.keys(VossRevenueRecognitionBehaviourText).map(Number) as VossRevenueRecognitionBehaviour[];
